module.exports = __webpack_public_path__ + "h5/img/broker_img2.6485ea04.jpg";